'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var cookie = require('react-cookie');
var superagent = require('superagent');
var Tracker = require('./tracker');
var legacyIESupport = require('superagent-legacyiesupport');

var Helpers = {
  $: function $(selector, parent) {
    if (!document) return false;
    if (!parent) parent = document;
    return parent.querySelector(selector);
  },
  $$: function $$(selector, parent) {
    if (!document) return false;
    if (!parent) parent = document;
    return parent.querySelectorAll(selector);
  },

  // Traverse upwards through the dom to find parent elements of an element, num in this function represents how many times you wish to move upwards from the starting element.
  getParentNode: function getParentNode(element, num) {
    var parent = element;
    for (var i = 0; i < num; i++) {
      if (parent.parentNode) parent = parent.parentNode;
    }
    return parent;
  },
  isVisible: function isVisible(selector, parent) {
    var item = this.$(selector, parent);
    if (!item) return false;
    return item.offsetWidth > 0 || item.offsetHeight > 0 || item.getClientRects().length > 0;
  },
  setCookie: function setCookie(cookieName, cookieValue, expiry, domain) {
    var cookieExpiryDays = 90;
    if (this.props && this.props.settings) {
      var settings = this.props.settings;

      if (settings.cookieExpiryDays) cookieExpiryDays = settings.cookieExpiryDays;
    }
    if (!expiry) {
      expiry = new Date();
      expiry.setTime(expiry.getTime() + cookieExpiryDays * 24 * 60 * 60 * 1000);
    }
    var opts = { expires: expiry, path: '/' };
    if (this.props && this.props.settings) {
      var _settings = this.props.settings;

      if (_settings.cookieDomain) opts.domain = _settings.cookieDomain;
    } else {
      if (domain) opts.domain = domain;
    }
    cookie.save(cookieName, cookieValue, opts);
  },
  getCookie: function getCookie(cookieName) {
    if (!cookieName) return false;
    return cookie.load(cookieName) || false;
  },
  getParameterByName: function getParameterByName(name, toUpperCase) {
    if (typeof window === 'undefined') return false;
    name = name.replace(/[[]/, '\\[').replace(/[/]]/, '\\]');
    name = toUpperCase ? name.toUpperCase() : name;
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var r = regex.exec(toUpperCase ? window.location.search.toUpperCase() : window.location.search);
    var result = '';
    if (r && r.length) {
      result = decodeURIComponent(r[1].replace(/\+/g, ' ') // Replace plus with spaces
      .replace(/%\s/g, '%25') // Replace single percent with encoded version
      .replace(/%$/, '%25') // Replace percentages at end with encoded version
      );
    }
    return result || false;
  },
  isSplitTest: function isSplitTest(name, percentage) {
    var data = false;
    var result = this.getParameterByName(name, false) || this.getCookie(name);
    if ((typeof percentage === 'undefined' ? 'undefined' : _typeof(percentage)) === 'object') {
      result = result || this.multiSplitTest(result, percentage);
      data = result;
    } else {
      result = result || this.singleSplitTest(percentage);
      data = result === 'show_alternative';
    }
    var variationVariableName = 'variationTracking' + name;
    if (typeof window !== 'undefined' && !window.hasOwnProperty(variationVariableName)) {
      window[variationVariableName] = true;
      var splitInfo = {
        'step': 'start',
        'test_name': name,
        'variant': result
      };
      Tracker.test(splitInfo);
    }
    this.setCookie(name, result);
    return data;
  },
  multiSplitTest: function multiSplitTest(result, testItems) {
    var start = 0;
    var random = Math.random() * 100;

    Object.keys(testItems).map(function (key) {
      if (!result && random >= start && random < testItems[key]) result = key;
      start = testItems[key];
    });

    if (!result) result = 'show_original';
    return result;
  },
  singleSplitTest: function singleSplitTest(percentage) {
    var random = Math.random() * 100;
    return random <= percentage ? 'show_alternative' : 'show_original';
  },
  getSmartyVariables: function getSmartyVariables(content) {
    var setVar = {};
    if (!content) return { setVar: setVar };
    var variables = content.match(/##setVariable:([^#]*)##/g);
    if (!variables) return { setVar: setVar };
    variables.map(function (item) {
      item = item.replace(/##/g, '').replace('setVariable:', '');

      var _item$split = item.split(':'),
          _item$split2 = _slicedToArray(_item$split, 2),
          key = _item$split2[0],
          value = _item$split2[1];

      setVar[key] = value;
    });
    return setVar;
  },
  getAgentLogo: function getAgentLogo() {
    var agentData = this.props.agentData ? this.props.agentData : this.state.agentData;
    if (!this.props.settings || !agentData) return;
    var requestUrl = 'hxml?plugin=library_image&seo=1&noDefault=1&type=smarty&limit=1&tags=logo_' + agentData.agent + '&noCache=1';
    var self = this;
    try {
      superagent.get(this.props.settings.soapiBase + requestUrl).end(function (err, res) {
        if (err || !res.body) return false;
        var data = res.body;
        if (!(data.link && data.hasOwnProperty('link')) || data.link === '') return;
        if (!(data.name && data.hasOwnProperty('name')) || data.name === '') return;
        var logo = 'https://static1.holidayextras.com' + data.link + data.name;
        self.setState({
          logo: logo
        });
      });
    } catch (e) {
      // console.log(e)
    }
  },
  checkForPreviousSearchCookie: function checkForPreviousSearchCookie(products) {
    if (!products) products = ['cp', 'ho', 'hcp', 'lo'];
    var today = new Date().getTime();
    var cookieDate = void 0;
    for (var i = 0; i < products.length; i++) {
      var cookieValue = this.getCookie('last_search_' + products[i]);
      if (!cookieValue) continue;
      var searchedObject = JSON.parse(JSON.stringify(cookieValue));
      if (products[i] === 'lo') {
        var dateTime = searchedObject.date_time.split(' ');
        if (!dateTime.length || !dateTime[1]) continue;
        cookieDate = new Date(new Date(dateTime[0]).setHours(dateTime[1].substr(0, 2)));
        if (today <= cookieDate.getTime()) return true;
      } else if (products[i] === 'cp') {
        if (!searchedObject.park_from) continue;
        cookieDate = new Date(new Date(searchedObject.date_out).setHours(searchedObject.park_from.substr(0, 2)));
        if (today <= cookieDate.getTime()) return true;
      } else if (today <= new Date(searchedObject.date_out).getTime() || today <= new Date(searchedObject.date_stay).getTime()) {
        return true;
      }
    }
    return false;
  },

  // Returns a promise
  emailToHash: function emailToHash(email, callback) {
    if (!email) return false;
    var requestUrl = '//static1.holidayextras.com/datafeeds/soapi/user-profile?email=' + email;
    return this.userProfileFetch(requestUrl, 'hash', callback);
  },

  // Returns a promise
  hashToEmail: function hashToEmail(hash, callback) {
    if (!hash) return false;
    var requestUrl = '//static1.holidayextras.com/datafeeds/soapi/user-profile?hash=' + hash;
    return this.userProfileFetch(requestUrl, 'email', callback);
  },
  userProfileFetch: function userProfileFetch(requestUrl, requestData, callback) {
    if (!callback) return;
    superagent.get(requestUrl).use(legacyIESupport).end(function (err, res) {
      if (err) return;
      var data = res.body;
      try {
        var resolveData = requestData === 'email' ? data.data.customer.email : data.data.customer.userExtId;
        callback(resolveData);
      } catch (e) {}
    });
  }
};

module.exports = Helpers;


// WEBPACK FOOTER //
// ./_plugins/lib/helpers.js